<template>
  <ListView
    modelName="StockReplenishmentCommodity"
    perm="stock.menu_stock_replenishment_commodity"
    svg="icon_side_stock"
    :items.sync="items"
    :params.sync="params"
    title="menu_stock_replenishment_commodity"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="StockReplenishmentCommodity"
    :gridCaptions="gridConfig.gridCaptions"
    :gridWidths="gridConfig.gridWidths"
    :importQuery="null"
    :exportQuery="exportQuery"
    class="Stock_ReplenishmentCommodity"
    borderColor="#61AA72"
    backColor="#EAFFEF"
    tooltip="検索条件で指定した基準日の予定在庫数量を確認することができます。商品マスタの仕入先・補充基準数量・補充数量を設定しておくと、【発注処理】ボタンで、補充が必要な商品を簡単に発注することができます。<br><br>設定の方法は<a href='https://support.s-flow.net/ja/articles/6869757' target='_blank'>サポートサイト</a>をご確認ください。"
    :popup="popup"                
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="gridConfig.gridSlots[0]" >{{ params.baseDate | date}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item }">{{ item.commodity.code}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.commodity.name}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.commodity.model}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.sku ? item.sku.name : '' }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.isShortage | listShortageFlags}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.commodity.supplier?item.commodity.supplier.name:''  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.commodity.uom}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }">{{ item.scheduleQuantity | numeric(item.quantityScale) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }">{{ item.minimumStockQuantity | numeric(item.quantityScale) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }">{{ item.commodity.replenishmentQuantity | numeric(item.quantityScale) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }">{{ item.replenishmentUom != null ? item.replenishmentUom.name : item.commodity.uom}}</GridItem>
    <!-- <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :right="true">{{ item.beginningTotalStockQuantity | numeric(item.quantityScale) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item}" :right="true">{{ item.totalTransferQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item}" :right="true">{{ item.purchaseQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item}" :right="true">{{ item.salesQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item}" :right="true">{{ item.schedulePurchaseQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item}" :right="true">{{ item.scheduleSalesQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item}" :right="true">{{ item.backPurchaseOrderQuantity | numeric(item.quantityScale)  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item}" :right="true">{{ item.backSalesOrderQuantity | numeric(item.quantityScale)  }}</GridItem> -->

    <!-- <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ?  item.commodity.reserveText1 : item.reserveText1) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ?  item.commodity.reserveText2 : item.reserveText2) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[17]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ?  item.commodity.reserveText3 : item.reserveText3) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[18]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ?  item.commodity.reserveText4 : item.reserveText4) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[19]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ?  item.commodity.reserveText5 : item.reserveText5) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[20]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ?  item.commodity.reserveText6 : item.reserveText6) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[21]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ?  item.commodity.reserveMemo1 : item.reserveMemo1) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[22]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ?  item.commodity.reserveMemo2 : item.reserveMemo2) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[23]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ?  item.commodity.reserveMemo3 : item.reserveMemo3) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[24]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ?  item.commodity.reserveDate1 : item.reserveDate1) | date  }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[25]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ?  item.commodity.reserveDate2 : item.reserveDate2) | date }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[26]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ?  item.commodity.reserveDate3 : item.reserveDate3) | date }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[27]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ?  item.commodity.reserveList1 : item.reserveList1) | category_41 }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[28]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ?  item.commodity.reserveList2 : item.reserveList2) | category_42 }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[29]" slot-scope="{ item }">{{ (tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ?  item.commodity.reserveList3 : item.reserveList3) | category_43 }}</GridItem> -->

    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :edit="true" :copy="false" :del="false">
        <ListViewMenu title="発注処理" slot="main" v-if="$api.useSalesPurchaseOrderFunction" svg="icon_side_order" @click="showCreatePurchaseOrderDialog()" tooltip="選択した商品・SKUの発注を作成します。1度に複数の仕入先への発注はできません。" :perm="listView.perm + '.process'"/>
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :favoriteVisible="!popup">
        <Calendar title="基準日" :value.sync="params.baseDate" @changed="handler" :autoEntry="true" :dateFlag.sync="params.baseDateFlag" tooltip="指定した日付を基準として、その日時点の各数量を集計して予定在庫数量を計算します。"/>
        <AtcCounterpart title="仕入先" :value.sync="params.supplier" :needsSupplier="true" @changed="handler"/>
        <ComboBox title="補充対象" :value.sync="params.replenishmentType" list="replenishmentTypes" :showDefault="false" @changed="handler" tooltip="商品単位での補充か、SKU単位での補充かを選択します。"/>
        <ComboBox title="補充区分" :value.sync="params.isShortage" list="shortageTypes" :showDefault="false" :enabled="isShortageEnabled==true || params.supplier!=null" @changed="handler" tooltip="要補充：予定在庫数量が、【商品マスタ】または【SKUマスタ】の補充基準数量を下回っている商品のみを表示します。<br>補充対象のみ：【商品マスタ】または【SKUマスタ】の補充基準数量が設定されている商品のみを表示します。<br>※仕入先を指定するか、補充基準数量が設定された商品/SKUが2000件未満の場合に変更可能です。"/>
        <ComboBox title="予定在庫数量" :value.sync="params.showMinusType" list="showMinusTypes" :showDefault="false" :editor="editor" @changed="handler"  tooltip="予定在庫数がマイナスになる見込みの商品を検索することができます。"/>
        <ComboBox title="商品区分1" :value.sync="params.commodityCategory1" list="category_11" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分2" :value.sync="params.commodityCategory2" list="category_12" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分3" :value.sync="params.commodityCategory3" list="category_13" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分4" :value.sync="params.commodityCategory4" list="category_14" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分5" :value.sync="params.commodityCategory5" list="category_15" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <ComboBox title="商品区分6" :value.sync="params.commodityCategory6" list="category_16" @changed="handler" tooltip="指定した商品区分が一致する商品を検索することができます。"/>
        <FilterBox title="コード･名称･型番" :value.sync="params.codeNameModel"  @click="handler"  tooltip="商品マスタやSKUマスタのコード、名称、型番のいずれかに部分一致する商品を検索することができます。" />
      </Search>
    </template>

    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','数量詳細']" :spEditVisible="false">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <Calendar title="基準日" :value.sync="params.baseDate" :editor="editor" :enabled="false" tooltip="表示されている数量の基準日です。基準日時点での数量が表示されています。"/>              
              <TextBox title="商品コード" :value.sync="item.commodity.code" :editor="editor" :enabled="false" tooltip="商品情報です。【商品マスタ】で登録されている【コード】が表示されます。"/>
              <AtcCommodity title="商品" :value="item.commodity" :editor="editor" :enabled="false" tooltip="商品情報です。入荷時の【商品名称】ではなく、【商品マスタ】で登録されている【商品名称】が表示されます。" />
              <TextBox title="型番" :value.sync="item.commodity.model" :editor="editor" :enabled="false" tooltip="在庫商品の型番です。【商品マスタ】で登録されている【型番】が表示されます。"/>
              <AtcSKU title="SKU" :value="item.sku" :editor="editor" :commodity="item.commodity" :enabled="false" tooltip="在庫商品のSKU情報です。同一商品でもSKUにより別の在庫として扱われます。" />
              <CheckBox title="補充区分" :value.sync="item.isShortage" list="listShortageFlags" :editor="editor" :enabled="false"  tooltip="予定在庫数量が補充基準数量を下回っている場合、「要補充」と表示します。" />
              <AtcCounterpart title="仕入先" :value.sync="item.commodity.supplier" :editor="editor" :needsSupplier="true" :enabled="false" tooltip="【商品マスタ】で設定されている仕入先です。未設定の場合はこの画面からの発注処理はできません。"/>
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <NumericBox title="予定在庫数量" :value="item.scheduleQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="月初の在庫と基準日時点までの振替・入出荷・受発注残を加味した予定在庫の総量です。" />
              <TextBox title="計上単位" :value.sync="item.commodity.uom" :editor="editor" :enabled="false" tooltip="商品の計上単位です。"/>
              <NumericBox title="補充基準数量" :value="item.minimumStockQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="【商品マスタ】または【SKUマスタ】に設定されている補充基準数量です。" />
              <NumericBox title="補充数量" :value="item.replenishmentQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="【商品マスタ】または【SKUマスタ】に設定されている補充数量です。一括補充時の初期値として使用されます。" />
              <TextBox title="補充単位" :value="item.replenishmentUom != null ? item.replenishmentUom.name : item.commodity.uom" :editor="editor"  :enabled="false" :commodity="item.commodity" tooltip="【商品マスタ】または【SKUマスタ】に設定されている補充単位です。一括補充時の初期値として使用されます。"/>              
            </template>
          </EditPanel>
        </template>
        <!-- 数量詳細タブ -->
        <template slot="tab1" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 数量詳細タブ 左側 -->
            <template slot="left">
              <NumericBox title="月初在庫数量" :value="item.beginningTotalStockQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="前月から繰り越された月初の在庫数です。前月の在庫数の増減により変更されます。" />
              <NumericBox title="振替数量" :value="item.totalTransferQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="在庫移行、在庫移動、在庫振替、セット品組立・分解、棚卸（減耗）の総量です。" />
              <NumericBox title="入荷済み数量" :value="item.purchaseQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="入荷日が月初から基準日までに入荷が完了している総量です。" />
              <NumericBox title="出荷済み数量" :value="item.salesQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="出荷日が月初から基準日までに出荷が完了している総量です。" />
              <NumericBox title="入荷待ち数量" :value="item.schedulePurchaseQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="入荷日が基準日までの未完了の入荷の総量です。前月以前の数量も含みます。" />
              <NumericBox title="出荷待ち数量" :value="item.scheduleSalesQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="出荷日が基準日までの未完了の出荷の総量です。前月以前の数量も含みます。" />
              <NumericBox title="発注残数量" :value="item.backPurchaseOrderQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="入荷予定日が基準日までの確定済み発注残の総量です。前月以前の数量も含みます。" />
              <NumericBox title="受注残数量" :value="item.backSalesOrderQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="出荷予定日が基準日までの確定済み受注残の総量です。前月以前の数量も含みます。" />
            </template>
            <template slot="right">
              <NumericBox title="発注残数量(未定分)" :value="item.backPurchaseOrderNoScheduleQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="入荷予定日が未設定の確定済み発注残の総量です。" />
              <NumericBox title="受注残数量(未定分)" :value="item.backSalesOrderNoScheduleQuantity" :editor="editor" :enabled="false" :decimals="item.quantityScale" tooltip="出荷予定日が未設定の確定済み受注残の総量です。" />
            </template>
          </EditPanel>
        </template>
        <!-- <template slot="tab1" slot-scope="{ item, editor }"> -->
          <!-- <PnlReserveItems :item="item.stockKey()" :editor="editor" :enabled="false" :commodityAttribute="visibleTypes.ReadOnly" :stockAttribute="visibleTypes.ReadOnly"  :orderMemo="visibleTypes.None" :deliveryMemo="visibleTypes.None" :commodity="item.commodity" /> -->
        <!-- </template> -->
      </Editor>
    </template>   
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockReplenishmentCommodityView extends Vue {
  
@Watch('params.supplier')
  paramsSupplierChanged() {
    if(this.params.supplier==null){
      this.params.isShortage=Common.shortageTypes.None;
    }
}
@Watch('params.replenishmentType')
  paramsReplenishmentTypeChanged(){
    // 商品マスタの件数で検索条件の活性非活性を制御
    var countQuery = new Common.HasMinimumStockQuantityCountQuery();
    countQuery.replenishmentType = this.params.replenishmentType;
    this.$api.execute(countQuery).then(res=>{this.isShortageEnabled = res < 2000;});
  }




  public items: Common.StockReplenishmentCommodity[] = new Array(0);
  public params: Common.StockReplenishmentCommodityQuery = new Common.StockReplenishmentCommodityQuery();
  public exportQuery = new Common.StockReplenishmentCommodityExportQuery('予定在庫一覧',this.params);
  public tenantSettings: Common.TenantSettings = null;
  public visibleTypes = Common.visibleTypes;
  public usedTypes = Common.UsedTypes;
  public hasLicenseCurrency: boolean = false;
  public commodity:Common.Commodity;
  public sku:Common.SKU; 
  public isShortageEnabled: Boolean = false;
  @Prop({default:null}) public popup: Components.PopupEditor;
  @Prop() public baseDate:Date;
  @Prop() public supplierCode:string;
  @Prop() public replenishmentType:Common.ReplenishmentTypes;
  @Prop() public isShortage:boolean;

  public sortOptions: any = [
    { value: 'commodity', text: '商品' },
    { value: 'supplier', text: '仕入先' },
    { value: 'minimumStockQuantity', text: '補充基準数量' },
    { value: 'commodityCode', text: '商品コード' },
  ];

  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public createPurchaseOrder = Components.CreatePurchaseOrderFromCommodity;

  // 一覧でチェックされている情報
  public checkedItems: Array<Common.StockReplenishmentCommodity>= new Array(0);
  public getCheckedItems(){
    this.checkedItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedItems.push(obj);
      }
    });
  }

  public created() {

// ***** 予定在庫一覧画面の表示確認 *****
this.$api.issueGA4trackevent(this.$route.path,'【補充商品一覧】画面表示');

    this.tenantSettings = this.$api.tenantSettings;
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    this.gridConfig.setGridItemsFromCaptions(
      ['基準日','商品コード','商品', '型番', 'SKU','補充区分','仕入先','計上単位','予定在庫数量', '補充基準数量', '補充数量','補充単位'],
      [120, 120, 120, 120, 120, 120, 120, 120, 150, 150, 120, 120, 150, 120, 120, 120, 120, 120,]
    );
    // this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));

    // 検索条件を設定する
    if(this.baseDate) {
      this.params.baseDate = this.baseDate;
    }
    if(this.supplierCode) {
      this.params.supplierCode = this.supplierCode;
    }
    if(this.replenishmentType) {
      this.params.replenishmentType = this.replenishmentType;
    }
    if(this.isShortage) {
      this.params.isShortage = Common.shortageTypes.IsShort;
    }

    // 商品マスタの件数で検索条件の活性非活性を制御
    var countQuery = new Common.HasMinimumStockQuantityCountQuery();
    countQuery.replenishmentType = this.params.replenishmentType;
    this.$api.execute(countQuery).then(res=>{this.isShortageEnabled = res < 2000;});
  }
  //検索予備項目
  // public isSearchVisible(usedType: Common.UsedTypes){
  //     return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute || usedType == Common.UsedTypes.CommodityMemo ;
  // }
  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }
  
  // 発注処理ダイアログの表示
  public showCreatePurchaseOrderDialog(all:boolean = false) {

// ***** 補充商品一覧画面の発注処理押下確認 *****
this.$api.issueGA4trackevent(this.$route.path,'【補充商品一覧】発注処理・押下');

    this.getCheckedItems();
    let componentClass = Vue.extend(this.createPurchaseOrder);    
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedReplenishmentCommodity : this.checkedItems,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }
}
</script>
